import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Portal, Backdrop, IconButton, Typography } from '@mui/material';
import { useQuery } from 'react-fetching-library';

import Iconify from '../../../../components/Iconify';
import { FullScreenView } from './availability-status-details/FullScreenView';
import { getInitResortEventCampTableDataAction } from '../../../../services/request';

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 1999,
  minHeight: 440,
  outline: 'none',
  display: 'flex',
  position: 'fixed',
  overflow: 'hidden',
  flexDirection: 'column',
  margin: theme.spacing(3),
  boxShadow: theme.customShadows.z20,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.paper
}));

AvailabilityStatusDetails.propTypes = {
  isOpenCompose: PropTypes.bool,
  onCloseCompose: PropTypes.func
};

export default function AvailabilityStatusDetails({ isOpenCompose, onCloseCompose, parentFullScreen, data, submitCallback, allSeasons, allPeriods, allPackages, allStatusChoices, allAvailabilityLevels }) {
  const [treeObjects, setTreeObjects] = React.useState({});
  const { error, payload, loading } = useQuery(getInitResortEventCampTableDataAction());

  React.useEffect(() => {
    if (!error && !loading) {
      setTreeObjects(payload);
    }
  }, [error, loading, payload]);

  const handleClose = () => {
    onCloseCompose();
  };

  if (!isOpenCompose) {
    return null;
  }

  return (
    <Portal>
      <Backdrop sx={{ zIndex: 1998 }} open={true} />
      <RootStyle
        sx={{
          top: 0,
          left: 0,
          zIndex: 1999,
          margin: 'auto',
          width: {
            xs: 'calc(100% - 24px)',
            md: 'calc(100% - 20px)'
          },
          height: {
            xs: 'calc(100% - 24px)',
            md: 'calc(100% - 10px)'
          }
        }}
      >
        <Box
          sx={{
            pl: 3,
            pr: 1,
            height: 60,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6">{data ? (data.description || data.status_display || 'Status dostępności') : ''}</Typography>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <Iconify icon={'eva:close-fill'} width={20} height={20} />
          </IconButton>
        </Box>
        <FullScreenView
          data={data}
          submitCallback={submitCallback}
          handleClose={handleClose}
          allSeasons={allSeasons}
          allPeriods={allPeriods}
          allPackages={allPackages}
          allStatusChoices={allStatusChoices}
          allAvailabilityLevels={allAvailabilityLevels}
          treeObjects={treeObjects}
        />
      </RootStyle>
    </Portal>
  );
}
